export default __webpack_public_path__ + "static/media/nft7.453b8cdd.png";